<template>
    <div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Give Feedback</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br />
            <v-container>
                <v-row dense>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field readonly v-if="edit_flag" color="#0F2027" dense rounded outlined v-model="sel_ay_data" label="Academic Year" hint="Noneditable" persistent-hint></v-text-field>

                        <v-autocomplete v-else color="#0F2027" dense rounded required v-model="sel_ay_data" return-object :items="ay_std_div_list" item-text="ay" label="Select Academic Year*" outlined @change="getStd();" />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field readonly v-if="edit_flag" color="#0F2027" dense rounded outlined v-model="sel_std_data" label="Standard" hint="Noneditable" persistent-hint></v-text-field>

                        <v-autocomplete
                            v-else
                            :disabled="std_div_list==null"
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="sel_std_data"
                            return-object
                            :items="std_div_list"
                            :rules="sel_std_data == null || sel_std_data == '' ? ['required']: []"
                            item-text="std"
                            label="Standard*"
                            outlined
                            @change="getDiv"
                        />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field readonly v-if="edit_flag" color="#0F2027" dense rounded outlined v-model="div" label="Division" hint="Noneditable" persistent-hint></v-text-field>

                        <v-autocomplete
                            v-else
                            :disabled="sel_std_data == null"
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="div"
                            return-object
                            :items="div_list"
                            :rules="div == null || div == '' ? ['required']: []"
                            item-text="div_name"
                            label="Select Division*"
                            outlined
                            @change="getCourse"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field readonly v-if="edit_flag" color="#0F2027" dense rounded outlined v-model="crs" label="Subject" hint="Noneditable" persistent-hint></v-text-field>

                        <v-autocomplete
                            v-else
                            :disabled="div == null"
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="crs"
                            item-value="crs_off_id"
                            :items="crs_list"
                            :rules="crs == null || crs == '' ? ['required']: []"
                            item-text="crs_name"
                            label="Select Subject*"
                            outlined
                            @change="getCourseLearners"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field readonly v-if="edit_flag" color="#0F2027" dense rounded outlined v-model="crs_off_learner" label="Student" hint="Noneditable" persistent-hint></v-text-field>

                        <v-autocomplete
                            v-else
                            :disabled="crs == null"
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="crs_off_learner"
                            item-value="col_id"
                            :items="course_learner_list"
                            :rules="crs_off_learner == null || crs_off_learner == '' ? ['required']: []"
                            item-text="col_name"
                            label="Select Student*"
                            outlined
                        />
                    </v-col>
                </v-row>
                <v-row justify="space-around">
                    <v-col cols="12" sm="6" md="6">
                        <v-textarea :disabled="crs_off_learner == null" color="#0F2027" outlined name="input-7-4" label="Comment*" v-model="comment" :rules="comment == null || comment == '' ? ['required']: []"> </v-textarea>
                    </v-col>
                    <v-col align-self="center" cols="12" sm="4" md="4" v-if="edit_flag">
                        <v-text-field v-if="edit_flag" readonly color="#0F2027" dense rounded outlined v-model="date2" label="Feedback Date" hint="Noneditable" persistent-hint></v-text-field>
                    </v-col>
                    <v-col align-self="center" cols="12" sm="4" md="4" v-else>
                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    :disabled="crs_off_learner == null"
                                    dense
                                    rounded
                                    v-model="dateFormatted"
                                    :rules="dateFormatted == null || dateFormatted == '' ? [' Date is required']: []"
                                    label="Feedback Date*"
                                    hint="DD/MM/YYYY format"
                                    persistent-hint
                                    outlined
                                    @blur="date2 = parseDate(dateFormatted)"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker :disabled="crs_off_learner == null" v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-btn class="button" @click="close">Reset</v-btn>
                    <v-btn class="button" @click="update" v-if="edit_flag">Update</v-btn>
                    <v-btn class="button" @click="save" v-else :disabled="crs_off_learner == null">Save</v-btn>
                </v-row>
            </v-container>
        </v-card>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Previous Feedback</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br />
            <v-data-table :headers="headers" :items="student_feedback" class="elevation-1 mytable" dense :search="search">
                <!-- <template v-slot:top>
                    <v-toolbar flat dense color="white">
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details> </v-text-field>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog_save" persistent max-width="700px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="button" v-on="on">Add Student Feedback</v-btn>
                            </template>
                            <v-card>
                                <v-card-title class="toolbar">
                                    <span class="headline">Student Feedback</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row dense>
                                            <v-col cols="12" sm="4" md="4">
                                                <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd();" />
                                            </v-col>
                                            <v-col cols="12" sm="4" md="4">
                                                <v-autocomplete
                                                    :disabled="std_div_list==null"
                                                    color="#0F2027"
                                                    dense
                                                    rounded
                                                    required
                                                    v-model="sel_std_data"
                                                    return-object
                                                    :items="std_div_list"
                                                    item-text="std"
                                                    label="Standard"
                                                    outlined
                                                    @change="getDiv"
                                                />
                                            </v-col>
                                            <v-col cols="12" sm="4" md="4">
                                                <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list" item-text="div_name" label="Select Division" outlined @change="getCourse" />
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-autocomplete color="#0F2027" dense rounded required v-model="crs" item-value="crs_off_id" :items="crs_list" item-text="crs_name" label="Subject" outlined @change="getCourseLearners" />
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-autocomplete color="#0F2027" dense rounded required v-model="crs_off_learner" item-value="col_id" :items="course_learner_list" item-text="col_name" label="Child" outlined />
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12">
                                                <v-textarea color="#0F2027" outlined name="input-7-4" label="Comment" v-model="comment"></v-textarea>
                                            </v-col>
                                            <v-col cols="12" sm="4" md="4">
                                                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field
                                                            dense
                                                            rounded
                                                            v-model="dateFormatted"
                                                            :rules="dateFormatted == null || dateFormatted == '' ? [' Date is required']: []"
                                                            label="Feedback Date *"
                                                            hint="DD/MM/YYYY format"
                                                            persistent-hint
                                                            outlined
                                                            @blur="date2 = parseDate(dateFormatted)"
                                                            v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="button" @click="close">Cancel</v-btn>
                                    <v-btn class="button" @click="save">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template> -->
                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="20" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                        <v-avatar style="" size="20" class="edit-avatar">
                            <v-icon color="error" class="delete-v-icon mr-2" @click="deleteItem(item)">delete</v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            overlay: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            dialog_save: false,
            edit_flag: false,
            student_feedback: [],
            academic_year_list: [],
            from_academicyear: null,
            search: "",
            ay_std_div_list: null,
            std_div_list: null,
            sel_ay_data: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            crs_list: null,
            crs: null,
            course_learner_list: null,
            crs_off_learner: null,
            comment: null,
            comment_edit: null,
            menu2: false,
            dateFormatted: "",
            date2: new Date().toISOString().substr(0, 10),
            feedback_id: null,
            headers: [
                {
                    text: "Academic Year",
                    align: "left",
                    sortable: false,
                    value: "academic_year",
                },
                {
                    text: "Standard",
                    align: "left",
                    sortable: false,
                    value: "standard",
                },
                {
                    text: "Division",
                    align: "left",
                    sortable: false,
                    value: "division",
                },
                {
                    text: "Date",
                    align: "left",
                    sortable: false,
                    value: "date2",
                },
                {
                    text: "Subject",
                    align: "left",
                    sortable: false,
                    value: "subject",
                },
                {
                    text: "Child",
                    align: "left",
                    sortable: false,
                    value: "child",
                },
                {
                    text: "Comment",
                    align: "left",
                    sortable: false,
                    value: "comment",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
        }),

        watch: {
            dialog_save(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
            date2(val) {
                this.dateFormatted = this.formatDate(this.date2);
            },
        },
        mounted() {
            this.dateFormatted = this.formatDate(this.date2);
            this.onload();
        },
        methods: {
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        // this.sel_ay_data = res.data.curr_ay;
                        this.getFeedbackList();
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getFeedbackList() {
                // this.student_feedback;
                axios
                    .post("/Feedback/getFeedbackList")
                    .then((res) => {
                        this.student_feedback = res.data.student_feedback;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = this.sel_std_data.div_list;
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            getCourse() {
                const formData = {
                    standard: this.sel_std_data.std_id,
                    ay: this.sel_ay_data.ay_id,
                };
                axios
                    .post("/QuizQuestionBank/getCourse", formData)
                    .then((res) => {
                        this.crs_list = res.data.crs_list;
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            getCourseLearners() {
                const formData = {
                    standard: this.sel_std_data.std_id,
                    ay: this.sel_ay_data.ay_id,
                    crs_off_id: this.crs,
                };
                axios
                    .post("/Feedback/getCourseLearners", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.course_learner_list = res.data.course_learner_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            save() {
                if (this.sel_ay_data == null) {
                    this.showSnackbar("#b71c1c", "Please select Academic Year!");
                    return;
                } else if (this.sel_std_data == null) {
                    this.showSnackbar("#b71c1c", "Please select Standard!");
                    return;
                } else if (this.div == null) {
                    this.showSnackbar("#b71c1c", "Please select Division!");
                    return;
                } else if (this.crs == null) {
                    this.showSnackbar("#b71c1c", "Please select Subject!");
                    return;
                } else if (this.crs_off_learner == null) {
                    this.showSnackbar("#b71c1c", "Please select Student!");
                    return;
                } else if (this.comment == null) {
                    this.showSnackbar("#b71c1c", "Please enter Comment!");
                    return;
                } else if (this.hasWhiteSpace(this.comment)) {
                    this.showSnackbar("#b71c1c", "Please enter Comment!");
                    return;
                } else if (this.date2 == null) {
                    this.showSnackbar("#b71c1c", "Please select date!");
                    return;
                } else {
                    this.overlay = true;
                    const formData = {
                        standard: this.sel_std_data.std_id,
                        ay: this.sel_ay_data.ay_id,
                        crs_off_id: this.crs,
                        crs_off_learner_id: this.crs_off_learner,
                        comment: this.comment,
                        feedback_date: this.dateFormatted,
                    };
                    axios
                        .post("/Feedback/saveFeedback", formData)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4caf50", res.data.status_reason);
                                this.dialog_save = false;
                                this.onload();
                            } else {
                                this.showSnackbar("#b71c1c", res.data.status_reason);
                                this.dialog_save = false;
                            }
                            // this.course_learner_list = res.data.course_learner_list;
                        })
                        .catch((error) => {
                            window.console.log(error);
                        })
                        .finally(() => {
                            this.overlay = false;
                            this.close();
                            //close loader
                        });
                }
            },
            hasWhiteSpace(s) {
                var status = false;
                var reWhiteSpace = new RegExp(/^\s+$/);

                // Check for white space
                if (reWhiteSpace.test(s)) {
                    // alert("Please Check Your Fields For Spaces");
                    return true;
                }
                return false;
            },
            update() {
                if (this.comment == null || this.comment == "") {
                    this.showSnackbar("#b71c1c", "Please enter Comment!");
                    return;
                } else if (this.hasWhiteSpace(this.comment)) {
                    this.showSnackbar("#b71c1c", "Please enter Comment!");
                    return;
                } else {
                    this.overlay = true;
                    const formData = {
                        comment: this.comment,
                        id: this.feedback_id,
                    };
                    axios
                        .post("/Feedback/saveEditedFeedback", formData)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4caf50", res.data.status_reason);
                                this.edit_flag = false;
                                this.onload();
                            } else {
                                this.showSnackbar("#b71c1c", res.data.status_reason);
                            }
                            // this.course_learner_list = res.data.course_learner_list;
                        })
                        .catch((error) => {
                            window.console.log(error);
                        })
                        .finally(() => {
                            this.overlay = false;
                            this.close();
                            //close loader
                        });
                }
            },
            deleteItem(item) {
                const change = confirm("Are you sure you want to delete Feedback!");
                if (change) {
                    this.overlay = true;
                    const data = {
                        id: item.id,
                    };
                    axios
                        .post("/Feedback/deleteFeedback", data)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4caf50", res.data.status_reason);
                                this.student_feedback.splice(this.student_feedback.indexOf(item), 1);
                            } else {
                                this.showSnackbar("#b71c1c", res.data.status_reason);
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        })
                        .finally(() => {
                            this.overlay = false;
                        });
                }
            },
            editItem(item) {
                this.edit_flag = true;
                this.sel_ay_data = item.academic_year;
                this.sel_std_data = item.standard;
                this.div = item.division;
                this.date2 = item.date2;
                this.dateFormatted = item.date2;
                this.comment = item.comment;
                this.crs = item.subject;
                this.crs_off_learner = item.child;
                this.feedback_id = item.id;
            },
            close() {
                this.dialog_save = false;
                this.sel_ay_data = null;
                this.sel_std_data = null;
                this.div = null;
                this.crs = null;
                this.crs_off_learner = null;
                this.comment = null;
                this.date2 = null;
            },
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
</style>
